// <product-description> — two small jobs around the intro text in the buy column.
//
// 1. The intro is clamped to six lines in CSS. Whether it is ACTUALLY longer than
//    six lines depends on the column width and the font, which only the browser
//    knows — so the "læs mere" link ships hidden and is revealed only when the
//    text really is cut off. A word count in Liquid would have been a guess about
//    line length and would show the link on a three-line description.
// 2. Clicking it opens the full description further down the page and scrolls
//    there. Without JS the link is a plain fragment jump, which still lands on
//    the right section — it just arrives with the accordion closed.
//
// Handlers are bound once in the constructor and always registered by the same
// reference, so connectedCallback can run again — a section re-render in the
// theme editor does that — without stacking listeners.
class ProductDescription extends HTMLElement {
  constructor() {
    super();
    this.onResize = () => this.sync();
    this.onClick = (event) => this.reveal(event);
  }

  connectedCallback() {
    this.clamped = this.querySelector('[data-clamped]');
    this.link = this.querySelector('[data-read-more]');

    this.sync();
    window.addEventListener('resize', this.onResize);
    this.link?.addEventListener('click', this.onClick);
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
  }

  sync() {
    if (!this.clamped || !this.link) return;
    // +1 absorbs sub-pixel line heights, which otherwise report a one-line
    // description as overflowing.
    const overflows = this.clamped.scrollHeight > this.clamped.clientHeight + 1;
    this.link.toggleAttribute('hidden', !overflows);
  }

  reveal(event) {
    const href = this.link.getAttribute('href') || '';
    if (!href.startsWith('#')) return;
    const target = document.querySelector(href);
    if (!target) return; // no target: leave the browser's own jump alone

    event.preventDefault();
    // The full description lives in a <details>; opening it before scrolling
    // means the reader lands on the text rather than on a closed heading.
    const details = target.tagName === 'DETAILS' ? target : target.closest('details');
    if (details) details.open = true;
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }
}

if (!customElements.get('product-description')) {
  customElements.define('product-description', ProductDescription);
}
